import { MatSnackBarConfig } from "@angular/material/snack-bar";

export const toastDefaultConfig: MatSnackBarConfig = {
    duration: 5000,
    horizontalPosition: 'center',
    verticalPosition: 'top',
};